import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { numberWithCommas } from '../../../../utils/consts/index';
import { validation, validateForm } from '../../../../utils/validation';
import {
  Button,
  CreditCard,
  FileUpload,
  Input,
  RadioButton,
  ValidationMessage,
  Toast,
} from '../../../../component';
import { ChargeIcon } from '~svg';
import { paymentApi } from '../../../../services/apis';
import { submitPaymentForm } from '../../../../utils/consts/payment';

const UserWalletCard = ({ className, amount, cardNumber, direction, intl }) => {
  const [wallet, setWallet] = useState('');
  const [paymentType, setPaymentType] = useState('online');
  const [loading, setLoading] = useState();
  const [errors, setErrors] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastState, setToastState] = useState('danger');
  const [alertMessage, setAlertMessage] = useState('user.tryagain');

  const chargeWallet = async (file) => {
    setLoading(true);
    if (paymentType === 'online') {
      let currencyId = '5c6a7107e8a2a14358df03d3';
      try {
        const { url, method, inputs } = (
          await paymentApi.charge({
            data: {
              amount: parseFloat(wallet.replaceAll(',', '')),
              currencyId,
              description: '',
            },
          })
        )?.payload?.data;
        submitPaymentForm(url, method, inputs);
      } catch (err) {
        setToast(true);
        setToastState('danger');
        setAlertMessage('user.tryagain');
      } finally {
        setLoading(false);
        setWallet('');
      }
    } else if (paymentType === 'bank') {
      setToast(true);
      setToastState('success');
      setAlertMessage('sendticket.sentsuccessfully');
      setLoading(false);
      setWallet('');
    }
  };

  const handleChange = (type) => {
    setPaymentType(type);
  };

  const handleValidation = () => {
    let { error, result } = validateForm({
      wallet: validation.positiveNumber(wallet.replaceAll(',', '')).required()
        .errors,
    });
    if (!paymentType) {
      error = { ...error, type: ['form.required'] };
      result = false;
    }
    return { error, result };
  };

  return (
    <div className="w-100 px-0 pb-4">
      <Toast
        isOpen={toast}
        onClose={() => setToast(false)}
        state={toastState}
        position="bottom"
        message={intl.formatMessage({
          id: alertMessage,
        })}
        direction={direction}
      />
      <div
        className={`col-12 d-flex flex-column align-items-center px-0 py-4 ${className}`}
      >
        <CreditCard customClass="col-11 p-0">
          <div className="d-flex col-12 flex-column p-3">
            <div className="d-flex pt-5 align-items-start">
              <div className="d-flex col-5 pt-1 font-small align-items-end text-white">
                <FormattedMessage id="booking.fromwallet" />
              </div>
              <div className="d-flex col-7 flex-column font-large p-0 align-items-end">
                <span className="text-third-light">
                  <FormattedMessage id="profile.walletbalance" />
                </span>
                <span className="d-flex mt-2 text-third-light">
                  {numberWithCommas(amount)}&nbsp;
                  <FormattedMessage id="booking.toman" />
                </span>
              </div>
            </div>
            <span className="d-flex justify-content-center p-0 mt-5 font-xlarge text-white">
              {cardNumber && cardNumber.length >= 16
                ? `${cardNumber.substr(0, 4)} ${cardNumber.substr(
                    4,
                    4,
                  )} ${cardNumber.substr(8, 4)} ${cardNumber.substr(12, 4)}`
                : '---'}
            </span>
          </div>
        </CreditCard>
        <div className="col-11 pt-3 pb-2 p-0">
          <Input
            tabIndex="1"
            className="d-flex col-12 justify-content-start border border-white text-primary"
            type="text"
            name="wallet"
            value={wallet}
            label={intl.formatMessage({
              id: 'profile.chargeamount',
            })}
            themeMode="light"
            outSideLabel={true}
            outSideLabelPosition="top"
            onChange={(event) => {
              setWallet(
                numberWithCommas(event.target.value.replaceAll(',', '')),
              );
              setErrors({
                ...errors,
                wallet: validation
                  .positiveNumber(event.target.value.replaceAll(',', ''))
                  .required().errors,
              });
            }}
            iconUrl={<ChargeIcon size={20} color="#00798c" />}
            inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
            outSideLabelClass={`d-flex text-third ${
              direction === 'rtl'
                ? 'font-xxl-normal font-xl-small font-lg-msmall'
                : 'font-xxl-normal font-xl-small font-lg-msmall font-smaller'
            }`}
          />
          <ValidationMessage errors={errors?.wallet} />
        </div>

        <div className="d-flex flex-column justify-content-xxl-center justify-content-start align-items-xxl-center align-items-start text-white col-11 px-0">
          <div className="w-100 d-flex flex-xxl-row flex-column justify-content-xxl-between justify-content-start align-items-xxl-center align-items-start text-white px-0">
            <RadioButton
              tabIndex="2"
              key="online"
              name="online"
              label="profile.online"
              inputClassName="font-smaller border-0 font-weight-bold text-primary"
              checked={paymentType === 'online'}
              onChange={() => handleChange('online')}
              theme="light"
              isLocalization={true}
            />
            <RadioButton
              tabIndex="3"
              key="bank"
              name="bank"
              label="profile.bankreceipt"
              inputClassName="font-smaller border-0 font-weight-bold text-primary"
              checked={paymentType === 'bank'}
              onChange={() => handleChange('bank')}
              theme="light"
              isLocalization={true}
            />
          </div>
          {paymentType === 'online' ? (
            <Button
              name={`charge-online-wallet`}
              id={`charge-online-wallet`}
              label={intl.formatMessage({
                id: 'profile.increasebalance',
              })}
              className="btn-secondary mt-3 px-0"
              onClick={chargeWallet}
              loading={loading}
              disabled={loading || !handleValidation().result}
            />
          ) : (
            <FileUpload
              className="btn-secondary mt-3 px-0 button font-msmall"
              title={intl.formatMessage({
                id: 'profile.attachedPaymentReceipt',
              })}
              isOptional={true}
              recieveFile={(file) => chargeWallet(file)}
              disabled={wallet === ''}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default injectIntl(UserWalletCard);
